import React, { useEffect, useRef, useState } from "react";
import "./tooltip.scss";
export const Tooltip = _ref => {
  let {
    className,
    title,
    titleTag = "h4",
    content,
    children,
    onClick
  } = _ref;
  const [tooltipVisible, setTooltipVisible] = useState(false);
  const tooltipRef = useRef(null);
  const buttonRef = useRef(null);
  const TitleTag = titleTag;
  const showTooltip = () => {
    setTooltipVisible(true);
    if (onClick) {
      onClick();
    }
  };
  const hideTooltip = () => {
    setTooltipVisible(false);
  };
  const calculatePosition = () => {
    if (tooltipRef.current && buttonRef.current) {
      const tooltip = tooltipRef.current;
      const button = buttonRef.current;
      const {
        left: tooltipLeft
      } = tooltip.getBoundingClientRect();
      const computedStyles = window.getComputedStyle(tooltip);
      const maxWidth = parseInt(computedStyles.getPropertyValue("max-width"), 10);
      const viewportWidth = window.innerWidth || document.documentElement.clientWidth;
      const viewportMargin = 32;
      const remainingWidth = viewportWidth - tooltipLeft;
      let tooltipWidth = maxWidth;
      if (viewportWidth < maxWidth) {
        tooltipWidth = viewportWidth - viewportMargin * 2;
        if (tooltipWidth > remainingWidth) {
          const overflow = tooltipWidth - remainingWidth;
          tooltip.style.left = "".concat(tooltip.offsetLeft - (overflow + viewportMargin), "px");
        } else {
          tooltip.style.left = "".concat(tooltip.offsetLeft, "px");
        }
      } else if (maxWidth > remainingWidth) {
        const overflow = maxWidth - remainingWidth;
        tooltip.style.left = "".concat(tooltip.offsetLeft - (overflow + viewportMargin), "px");
      } else {
        const offset = maxWidth / 2;
        if (offset + viewportMargin > tooltipLeft) {
          tooltip.style.left = "".concat(tooltip.offsetLeft, "px");
        } else {
          tooltip.style.left = "".concat(tooltip.offsetLeft - offset, "px");
        }
      }
      tooltip.style.width = "".concat(tooltipWidth, "px");
      tooltip.style.top = "".concat(button.offsetTop + button.offsetHeight, "px");
    }
  };
  useEffect(() => {
    if (tooltipVisible) {
      calculatePosition();
      const handleClickOutside = event => {
        const clickedElement = event.target;
        const clickedElementIsTooltipTrigger = clickedElement === buttonRef.current || clickedElement.closest(".tooltip-trigger") === buttonRef.current;
        if (tooltipRef.current && !tooltipRef.current.contains(event.target) && !clickedElementIsTooltipTrigger) {
          hideTooltip();
        }
      };
      document.addEventListener("click", handleClickOutside);
      return () => {
        document.removeEventListener("click", handleClickOutside);
      };
    }
  }, [tooltipVisible]);
  return /*#__PURE__*/React.createElement("div", {
    className: "tooltip-container ".concat(className || "")
  }, /*#__PURE__*/React.createElement("button", {
    className: "tooltip-trigger",
    onClick: showTooltip,
    "aria-label": "".concat(title || "", "tooltip"),
    ref: buttonRef
  }, /*#__PURE__*/React.createElement("i", {
    className: "fa-regular fa-circle-info mr-3 mr-sm-2"
  }), children && children), tooltipVisible && /*#__PURE__*/React.createElement("div", {
    className: "tooltip border border-teal-20",
    ref: tooltipRef
  }, /*#__PURE__*/React.createElement("div", {
    className: "tooltip-body text-default"
  }, /*#__PURE__*/React.createElement("div", {
    className: "tooltip-title flex"
  }, title && /*#__PURE__*/React.createElement(TitleTag, {
    className: "mr-2",
    dangerouslySetInnerHTML: {
      __html: title
    }
  }), /*#__PURE__*/React.createElement("button", {
    className: "ml-auto tooltip-close",
    onClick: hideTooltip
  }, /*#__PURE__*/React.createElement("i", {
    className: "fa-regular fa-close"
  }))), /*#__PURE__*/React.createElement("div", {
    className: "tooltip-content mt-3 fs-small fw-400"
  }, content))));
};